import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { KenbanBoardRoutes } from '../../../routes';

export const KenbanBoardLayout = () => <SwitchRoute routes={KenbanBoardRoutes} />;
